import { useEffect, useState } from "react";
import icon from "assets/img/icons/special-offers.svg";
import { useAuth0 } from "@auth0/auth0-react";
import { usePopup } from "hooks/usePopup";
import { useLocation } from "react-router-dom";
import useProfile from "hooks/useProfile";
import { useSoundPath } from "hooks/useSoundPath";
import useActiveItem from "hooks/useActiveItem";
import BuyWidget from "components/onramper/BuyWidget";
import PagePopopCloseButton from "components/page-components/PagePopopCloseButton";

const PurchaseWindowStart = ({ currentQuantity, nextStep }) => {
  const { pathname } = useLocation();
  const { activeItem } = useActiveItem();
  const [isOnramper, setIsOnrumper] = useState(false);
  const { isLogged, balance } = useProfile();
  const { loginWithRedirect } = useAuth0();
  const setPopupHook = usePopup();
  const playSound = useSoundPath();

  const useAccountBalanceBtnHandler = () => {
    playSound("main");
    if (isLogged) {
      nextStep("confirm");
    } else {
      loginWithRedirect();
    }
  };

  const useAddFundsHandler = () => {
    playSound("main");
    setIsOnrumper(true);
  };

  useEffect(() => {
    if (isLogged) {
      setPopupHook({ type: "purchase" });
    }
  }, [isLogged]);

  return (
    <>
      {isOnramper ? (
        <>
          <PagePopopCloseButton close={() => setIsOnrumper(false)} />
          <BuyWidget />
        </>
      ) : (
        <>
          <header className="modal-window__header">
            <img src={icon} className="modal-window__icon" alt="" />
          </header>
          <form className="purchase-form">
            <output className="purchase-form__output">
              <span>Price</span>
              <span>
                ${(Number(activeItem.cost) * currentQuantity).toFixed(2)}
              </span>
            </output>
            <section className="purchase-form__balance">
              <span className="purchase-form__balance-title">
                Your account balance is:
              </span>
              <b className="purchase-form__balance-current">
                ${balance ? balance : 0} USD
              </b>
              {balance < activeItem.cost * currentQuantity && (
                <p className="purchase-form__balance-error">
                  Your balance is insufficient
                </p>
              )}
            </section>
            <footer className="modal-window__footer">
              <button
                className="modal-window__footer-close"
                type="button"
                onClick={useAccountBalanceBtnHandler}
                disabled={balance < activeItem.cost * currentQuantity}
              >
                Use account balance
              </button>
              {!pathname.includes("marketplace") && (
                <button
                  className="modal-window__footer-submit"
                  type="button"
                  onClick={useAddFundsHandler}
                >
                  Add Funds to My Account
                </button>
              )}
            </footer>
          </form>
        </>
      )}
    </>
  );
};

export default PurchaseWindowStart;
